
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"pt8cb2bzxa","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h24v24H0z"}})]),_c('g',{attrs:{"mask":"url(#pt8cb2bzxa)"}},[_c('path',{attrs:{"d":"M17 3v2h-1v8.175l-9-9V3h10zm-5 20l-1-1v-6H6v-2l2-2v-1.15L1.4 4.2l1.4-1.4 18.4 18.4-1.45 1.4-6.6-6.6H13v6l-1 1z","fill":"currentColor"}})])])
          )
        }
      }
    